export default "__VITE_ASSET__eb2ac40e__"